import { graphql, useStaticQuery } from "gatsby"

export const useFooterMenu3 = () => {
  const { allWpMenu } = useStaticQuery(
    graphql`
      query FOOTER_MENU_3 {
        allWpMenu(filter: { slug: { eq: "footer-menu-3" } }) {
          nodes {
            databaseId
            name
            count
            slug
            menuItems {
              nodes {
                id
                label
                url
              }
            }
          }
        }
      }
    `
  )

  const { nodes: [ node = {} ] } = allWpMenu
  const {
    menuItems: { nodes: menuItems = [] }
  } = node
  return [menuItems]
}